<template>
  <div class="s6">
    <div class="container">
      <img src="@/assets/home/s6/title.png" class="title" alt="" />
      <div class="img-wrapper">
        <img v-for="item in iconList" :key="item.id" :src="item.icon" alt="" class="icon" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      iconList: [
        {
          id: 1,
          icon: require("@/assets/home/s6/logo1.png"),
        },
        {
          id: 2,
          icon: require("@/assets/home/s6/logo2.png"),
        },
        {
          id: 3,
          icon: require("@/assets/home/s6/logo3.png"),
        },
        {
          id: 4,
          icon: require("@/assets/home/s6/logo4.png"),
        },
        {
          id: 5,
          icon: require("@/assets/home/s6/logo5.png"),
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.s6 {
  width: 100%;
  height: 533px;
  background: #fff;
  padding-top: 120px;
  box-sizing: border-box;
  margin: 0 auto;
  .container {
    // width: 1600px;
    height: 233px;
    margin: 0 auto;
    text-align: left;
    .title {
      width: 643px;
      height: 53px;
    }
    .img-wrapper {
      position: relative;
      margin-top: 80px;
      white-space: nowrap;
      overflow: hidden;
    }
  }
}

@media screen {
  @media (min-width: 1617px) {
    .s6 {
      min-width: 1600px;
    }
    .container {
      width: 1600px;
      .img-wrapper {
        width: 1600px;
        height: 103px;
      }
      .icon {
        width: 300px;
        height: 103px;
      }
    }
  }

  @media (min-width: 1201px) and (max-width: 1616px) {
    .container {
      width: 90%;
      .img-wrapper {
        @width: 100%;
        width: @width;
        // height: calc(100% * 0.064375);

        .icon {
          width: 20%;
        }
      }
    }
  }

  @media (max-width: 1200px) {
    .s6 {
      width: 1200px;
    }
    .container {
      width: 1083px;
      .img-wrapper {
        width: 1083px;
        .icon {
          width: 20%;
          // height: 82.17px;
        }
      }
    }
  }
}
</style>
